export class DashboardParam {
    orderDateType?: DashboardOrderDateType = DashboardOrderDateType.ORDER_DATE;
    dashboardCustomerType?: DashboardCustomerType;
    municipalities?: string[] = [];
    productMerchandiseGroups?: string[] = [];
    periodFrom?: string | Date;
    periodTo?: string | Date;
    pointsOfSale?: string[] = [];
    deliveryLocations?: string[] = [];
}

export class Dashboard {
    dashboardGraphType?: DashboardGraphType;
    data?: any;
    translated?: string;

    // helper
    show?: boolean = false;
    sources?: any;
}

export enum DashboardGraphType { 
    ORDERS_CUSTOMERS_BY_HOUR = 'ORDERS_CUSTOMERS_BY_HOUR',
    ORDERS_CUSTOMERS_BY_DATE = 'ORDERS_CUSTOMERS_BY_DATE',
    ORDERS_CUSTOMERS_BY_MUNICIPALITY = 'ORDERS_CUSTOMERS_BY_MUNICIPALITY',
    TOP_PRODUCTS = 'TOP_PRODUCTS',
    TOP_CATEGORIES = 'TOP_CATEGORIES',
    TOP_CUSTOMERS = 'TOP_CUSTOMERS',
    B2B_ORDERS_BY_ORDER_STATUS = 'B2B_ORDERS_BY_ORDER_STATUS',
    B2B_ORDERS_BY_DELIVERY_STATUS = 'B2B_ORDERS_BY_DELIVERY_STATUS',
    B2B_TOP_PRODUCTS = 'TOP_PRODUCTS',
    B2B_TOP_CATEGORIES = 'TOP_CATEGORIES'
}

export enum DashboardOrderDateType {
    ORDER_DATE = 'ORDER_DATE',
    DELIVERY_DATE = 'DELIVERY_DATE'
}

export enum DashboardCustomerType {
    REGISTERED = 'REGISTERED',
    PUBLIC = 'PUBLIC'
}